import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { apiHandler } from '../../api/apihandler';
import { COMMENT_LIST } from "../../api/constants";
import SingleUserComment from './singleUserComment'


const CommentList = ({ postId, refreshCommentList, setRefreshCommentList, onCommentAdded, onCommentDeleted }) => {
    const navigate = useNavigate();
    const [commentList, setCommentList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    // Load on mount
    useEffect(() => {
        getCommentList()
    }, [postId])

    // Reload whenever the counter increments (skip initial value of 0)
    useEffect(() => {
        if (refreshCommentList > 0) {
            getCommentList()
        }
    }, [refreshCommentList])

    async function getCommentList() {
        setIsLoading(true)
        try {
            const res = await apiHandler(COMMENT_LIST, "POST", {
                page: 1,
                limit: 100,
                post_id: postId
            })
            if (res.data?.response?.status === 200) {
                setCommentList(res?.data?.data?.comments?.data ?? [])
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <>
            <div className="comment-area mt-3" style={{ marginTop: "10px" }}>
                <h5 style={{ marginTop: "5px" }}>List of Comments</h5>
                {isLoading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ padding: "20px 0" }}>
                        <div className="spinner-border spinner-border-sm text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <span className="ms-2 text-muted" style={{ fontSize: "14px" }}>Loading comments...</span>
                    </div>
                ) : commentList?.length === 0 ? (
                    <p className="text-muted text-center" style={{ fontSize: "14px", padding: "16px 0" }}>No comments yet. Be the first to comment!</p>
                ) : (
                    commentList?.map((elm, i) => (
                        <div key={elm?.id}>
                            <SingleUserComment postId={postId} commentElm={elm} setRefreshCommentList={setRefreshCommentList} depth={0} onCommentAdded={onCommentAdded} onCommentDeleted={onCommentDeleted} />
                            {
                                elm?.replies?.map((innerElm, index) => (
                                    <div key={innerElm?.id} style={{ marginLeft: "40px" }}>
                                        <SingleUserComment postId={postId} commentElm={innerElm} setRefreshCommentList={setRefreshCommentList} depth={1} onCommentAdded={onCommentAdded} onCommentDeleted={onCommentDeleted} />
                                        {
                                            innerElm?.replies?.map((innerElm2, index) => (
                                                <div key={innerElm2?.id} style={{ marginLeft: "40px" }}>
                                                    <SingleUserComment postId={postId} commentElm={innerElm2} setRefreshCommentList={setRefreshCommentList} depth={2} onCommentAdded={onCommentAdded} onCommentDeleted={onCommentDeleted} />
                                                    {
                                                        innerElm2?.replies?.map((innerElm3, index) => (
                                                            <div key={innerElm3?.id} style={{ marginLeft: "40px" }}>
                                                                <SingleUserComment postId={postId} commentElm={innerElm3} setRefreshCommentList={setRefreshCommentList} depth={3} onCommentAdded={onCommentAdded} onCommentDeleted={onCommentDeleted} />
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            ))
                                        }
                                    </div>
                                ))
                            }
                        </div>
                    ))
                )}
            </div>
        </>
    )
}

export default CommentList
